import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { TOKENEX_VARS } from '@/config/env';
import { TokenizeCard } from '@/types/Tokenex';

const { SERVER_URL, API, SCHEME, ID } = TOKENEX_VARS;

export const tokenexApi = createApi({
  reducerPath: 'thirdparty/tokenexApi',
  keepUnusedDataFor: 300,
  baseQuery: fetchBaseQuery({ baseUrl: `${SERVER_URL}/v2/Pci` }),
  tagTypes: ['Tokenize'],
  endpoints: builder => ({
    tokenizeCard: builder.query<TokenizeCard, { data: string; cvv?: string }>({
      query: payload => ({
        url: `/Tokenize`,
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          'tx-apikey': API,
          'tx-token-scheme': SCHEME,
          'tx-tokenex-id': ID,
        },
        body: JSON.stringify({
          data: payload.data,
          ...(payload.cvv ? { cvv: payload.cvv } : {}),
        }),
      }),
      transformResponse: (response: { data: TokenizeCard }, meta, arg) => response.data,
      providesTags: ['Tokenize'],
    }),
  }),
});

export const { useTokenizeCardQuery } = tokenexApi;
